import { FC } from 'react';
interface PlaceholderProps {
  componentId: string;
}

const Placeholder: FC<React.PropsWithChildren<PlaceholderProps>> = ({
  componentId = '',
}) => (
  <>
    <div className="bg-purple40 py-30px shadow-inner shadow-red100 z-30">
      <p className="flex font-bold items-center justify-center text-white">
        <span className="mx-15px text-headline2">&#9888;</span> Placeholder:
        Component &quot;
        <strong>{componentId}</strong>
        &quot; has not been integrated yet.
      </p>
    </div>
  </>
);

export default Placeholder;
